import React from 'react';

const steps = [
  {
    icon: '/img/icons/image-check.svg',
    description: (
      <>
        Select your preferred resource from our{' '}
        <a href="/professionals/resources/marketing-toolkit/request-toolkit" className="plain-text-link plain-text-link--underline">toolkit enquiry form</a>{' '}
        and fill in the required details.
      </>
    ),
  },
  {
    icon: '/img/icons/annotation-check.svg',
    description: 'After you have submitted the form, a team member will contact you to confirm your request.',
  },
  {
    icon: '/img/icons/magic-wand-01.svg',
    description: 'You will receive the resources to be reviewed by you and your compliance department.',
  },
  {
    icon: '/img/icons/check-heart-alt.svg',
    description: 'Once you are happy with your resources, we will send you the final digital versions.',
  },
];

export const GetStartedSteps = () => (
  <div className="container mx-auto">
    <div className="pb-8 md:pb-[2.75rem]">
      <h2 className="text-3xl md:text-4xl text-[#0C0D1A] font-semibold pb-8 md:pb-[2.75rem] text-center">
        How to get started
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-10">
        {steps.map((step, index) => (
          <div key={index} className="relative h-[14.25rem]">
            <div className="bg-[rgba(220,238,250,0.80)] rounded-lg p-4 flex flex-col items-center justify-center text-center h-full">
              <div className="mb-4 flex justify-center">
                {/* Default icon display - hidden on XL for positions 1 and 2 due to icon swap */}
                <img
                  src={step.icon}
                  alt={step.title || `Step ${index + 1}`}
                  className={index === 1 || index === 2 ? 'xl:hidden' : ''}
                />

                {/* Swap icons for positions 1 and 2 on XL screens */}
                {index === 1 && (
                  <img
                    src={steps[2].icon}
                    alt={step.title || `Step ${index + 1}`}
                    className="hidden xl:block"
                  />
                )}

                {index === 2 && (
                  <img
                    src={steps[1].icon}
                    alt={step.title || `Step ${index + 1}`}
                    className="hidden xl:block"
                  />
                )}
              </div>
              <p className="text-sm text-[#373945] font-medium">{step.description}</p>
            </div>

            {index < steps.length - 1 && (
              <>
                {/* Down arrow for mobile */}
                <div className="block md:hidden absolute -bottom-8 left-1/2 transform -translate-x-1/2">
                  <img src="/img/icons/chevron-down.svg" alt="chevron-down" className="w-6 h-6" />
                </div>
                {/* Right arrow for md and above, only between the first and second column */}
                {index % 2 === 0 && (
                  <div className="hidden md:block absolute top-1/2 -right-8 transform -translate-y-1/2">
                    <img src="/img/icons/chevron-right.svg" alt="chevron-right" className="w-6 h-6" />
                  </div>
                )}
                {(index + 1) % 4 !== 0 && (
                  <div className="hidden xl:block absolute top-1/2 -right-8 transform -translate-y-1/2">
                    <img src="/img/icons/chevron-right-default.svg" alt="chevron-right" className="w-6 h-6" />
                  </div>
                )}
              </>
            )}
          </div>
        ))}
      </div>
    </div>
    <div className="flex justify-center">
      <p className="text-sm text-[#000] font-450 text-center md:w-[30rem] lg:w-[60rem]">
        By using our white-label marketing services you will be liable for any compliance breaches and advertising at your own risk.
        Equity release advisers must always run communications by their compliance department and add any necessary disclaimers if needed.
      </p>
    </div>
  </div>
);
